module.exports = __webpack_public_path__ + "Roboto-ThinItalic.11b5cc9584f2c007a229.ttf";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-ThinItalic.ttf
// module chunks = 5